var _defs, _g, _path;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgCertivlogonew(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 400 200",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .st0 {\n        fill: url(#linear-gradient);\n      }\n\n      .st1 {\n        fill: #fff;\n      }\n    "), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: 38.9,
    y1: 123.75,
    x2: 102.49,
    y2: 78.42,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#0058ff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.03,
    stopColor: "#005dfe"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.28,
    stopColor: "#008afe"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.41,
    stopColor: "#009cfe"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.52,
    stopColor: "#06a5f5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7,
    stopColor: "#16bfde"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.93,
    stopColor: "#31e9b9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3af7ad"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M172.04,117.28v-35.39h36.27v7.01h-27.36v6.96h24.16v6.9h-24.16v7.47h27.77v7.06h-36.68Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M216.6,117.28v-35.39h28.59c2.54,0,4.63.52,6.26,1.55,1.63,1.03,2.86,2.39,3.68,4.07.82,1.68,1.24,3.55,1.24,5.62s-.54,4.11-1.62,5.95c-1.08,1.84-2.72,3.29-4.92,4.35l7.37,13.86h-9.99l-6.23-12.26h-15.46v12.26h-8.91ZM225.51,98.02h17.05c1.44,0,2.58-.44,3.43-1.31.84-.88,1.26-2,1.26-3.37,0-.96-.19-1.77-.57-2.42-.38-.65-.91-1.15-1.6-1.49-.69-.34-1.53-.52-2.52-.52h-17.05v9.12Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M275.89,117.28v-27.87h-15.61v-7.52h40.03v7.52h-15.56v27.87h-8.86Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M306.39,117.28v-35.39h8.91v35.39h-8.91Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M337.82,117.28l-16.95-35.39h9.89l8.65,18.85c.38.79.76,1.67,1.16,2.65.39.98.79,1.93,1.19,2.86.39.93.71,1.73.95,2.42h.41c.24-.62.54-1.38.9-2.29.36-.91.75-1.85,1.18-2.83.43-.98.83-1.9,1.21-2.76l8.71-18.91h9.43l-16.95,35.39h-9.79Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M139.35,88.9h24.81v-7.01h-28.3c-5.2,0-9.62,3.73-10.58,8.84-.53,2.84-.81,5.8-.81,8.85s.28,6.02.81,8.85c.95,5.11,5.38,8.84,10.58,8.84h28.3v-7.01h-24.7c-2.09,0-3.92-1.45-4.36-3.49-.51-2.37-.78-4.88-.78-7.48,0-2.36.23-4.64.65-6.81.41-2.09,2.25-3.6,4.38-3.6Z"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M109.07,102.08h-15.87c-14.13.15-17.68,2.69-18.14,15.67-.04,1.19-1.01,2.15-2.2,2.16h0c-1.21.01-2.21-.95-2.25-2.16-.46-13-4-15.85-18.1-16.01h-.17c-1.2,0-2.18-.97-2.18-2.18h0c0-1.2.97-2.18,2.18-2.18h.13c14.13-.15,17.68-2.99,18.14-16.01.04-1.19,1.01-2.15,2.2-2.16h0c1.21-.01,2.21.95,2.25,2.16.46,12.99,4.01,15.52,18.14,15.67h15.87c.47,0,.86-.4.83-.87-.23-4.37-.89-8.59-1.93-12.58-1.07-4.1-3.43-7.45-7.67-7.45h-54.96c-4.16,0-6.55,3.26-7.62,7.27-1.34,5.05-2.07,10.48-2.07,16.13s.7,10.86,1.98,15.82c1.08,4.16,3.4,7.59,7.7,7.59h54.95c4.24,0,6.6-3.35,7.67-7.45s1.7-8.2,1.93-12.58c.02-.47-.36-.87-.83-.87Z"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCertivlogonew);
export default __webpack_public_path__ + "static/media/certivlogonew.65a6f9bc3aa8099e73efe4ffafe6f4a9.svg";
export { ForwardRef as ReactComponent };